import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleLobbyChatInitialized } from '../chat/actions.any';
import { approveKnockingParticipant, rejectKnockingParticipant } from '../lobby/actions.web';
/**
 * Hook used to create admit/reject lobby actions.
 *
 * @param {Object} participant - The participant for which the actions are created.
 * @param {Function} closeDrawer - Callback for closing the drawer.
 * @returns {Array<Function>}
 */
export function useLobbyActions(participant, closeDrawer) {
    const dispatch = useDispatch();
    return [
        useCallback(e => {
            var _a;
            e.stopPropagation();
            dispatch(approveKnockingParticipant((_a = participant === null || participant === void 0 ? void 0 : participant.participantID) !== null && _a !== void 0 ? _a : ''));
            closeDrawer === null || closeDrawer === void 0 ? void 0 : closeDrawer();
        }, [dispatch, closeDrawer]),
        useCallback(() => {
            var _a;
            dispatch(rejectKnockingParticipant((_a = participant === null || participant === void 0 ? void 0 : participant.participantID) !== null && _a !== void 0 ? _a : ''));
            closeDrawer === null || closeDrawer === void 0 ? void 0 : closeDrawer();
        }, [dispatch, closeDrawer]),
        useCallback(() => {
            var _a;
            dispatch(handleLobbyChatInitialized((_a = participant === null || participant === void 0 ? void 0 : participant.participantID) !== null && _a !== void 0 ? _a : ''));
        }, [dispatch])
    ];
}
/**
 * Hook used to create actions & state for opening a drawer.
 *
 * @returns {Array<any>}
 */
export function useParticipantDrawer() {
    const [drawerParticipant, openDrawerForParticipant] = useState(null);
    const closeDrawer = useCallback(() => {
        openDrawerForParticipant(null);
    }, []);
    return [
        drawerParticipant,
        closeDrawer,
        openDrawerForParticipant
    ];
}
